
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produtores/page/[slug]",
      function () {
        return require("private-next-pages/produtores/page/[slug].tsx");
      }
    ]);
  